import { AfterViewInit, Component, OnInit } from "@angular/core";
import { LoaderService } from "./shared/services/loader.service";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { AngularFireAuth } from "angularfire2/auth";
import { AuthService } from "./shared/services/auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements AfterViewInit, OnInit {
  title = "app";
  idleState = "Not started.";
  timeoutWarning = false;
  timedOut = false;
  lastPing?: Date = undefined;
  private subscription: Subscription;
  private authInstance: AngularFireAuth;

  constructor(
    private router: Router, public loaderService: LoaderService,
    private authService: AuthService,
    private idle: Idle, private keepalive: Keepalive ) {
    localStorage.removeItem("firebase:previous_websocket_failure");
    this.authInstance = this.authService.getAngularFireAuthInstance();
  }

  ngAfterViewInit(): void {
    this.authInstance.authState.subscribe(user => {
      if (user) {
        this.startSession();
      }
    });
  }

  ngOnInit(): void {
    this.idleState = "Timed out!";
    this.timedOut = true;
    this.idle.ngOnDestroy();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loaderService.startLoader();
      } else if (event instanceof NavigationEnd) {
        this.loaderService.stopLoader();
      }
    });
  }

  startSession(): void {
    this.idle.setIdle(1140);
    this.idle.setTimeout(60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => this.idleState = "No longer idle.");

    this.idle.onTimeout.subscribe(() => {
      this.authInstance.auth
        .signOut().then(res => {
          this.subscription.unsubscribe();
          this.router.navigate(["/account/login"]);
        });
    });

    this.idle.onIdleStart.subscribe(() => this.idleState = "You\"ve gone idle!");

    this.keepalive.interval(15);
    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
    this.subscription = Observable.fromEvent(document, "mousemove").subscribe(res => this.reset());
  }

  reset(): void {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts